import * as T from "./types"
import commands from "./data/commands.json" assert { type: "json" }

export const ProjectorCommands = commands as {
	[key in T.ProjectorMake]: {
		[key in T.ProjectorCommandInterface]: {
			[key in T.ProjectorCommand]: string
		}
	}
}

export * from "./types"
